import { Select } from './Select';
import IconDiv from './IconDiv';
import { Button } from './Button';
import faArrowDown from '../img/icons/down.svg';
import faArrowUp from '../img/icons/up.svg';

const BarWithSelectOnDesktop = ({
  companyDietDetails,
  path,
  showSelect,
  selectDiet,
  selectNextDiet,
  selectedDiet,
}) => {
  return (
    <div className="menu-widget-catering-menu__carousel-diets-desktop noselect">
      {companyDietDetails?.length > 0 && (
        <div className="display-flex" style={{ width: 500 }}>
          <div className="spacer-right-8 spacer-left-4" style={{ width: 400 }}>
            <Select
              dietUrl
              items={companyDietDetails}
              selectedItem={selectedDiet}
              selectedItemKey="dietName"
              selectItem={diet => selectDiet(diet)}
              id="menuPicker"
              path={path}
              disabled={!showSelect}
              showSelect={showSelect}
            />
          </div>
          {showSelect && (
            <>
              <Button
                // classes={classNames({
                //     'button__arrow--mobile': !isWide
                // })}
                colorBlank
                containerClass="menu-widget-button-fixed-height spacer-right-4"
                icon={
                  <IconDiv
                    classes="menu-widget-catering-menu-bar-with-select-on-desktop-icon--arrow"
                    path={path}
                    url={faArrowDown}
                  />
                }
                onClick={() => selectNextDiet('down')}
              />
              <Button
                colorBlank
                containerClass={'menu-widget-button-fixed-height '}
                icon={
                  <IconDiv
                    classes="menu-widget-catering-menu-bar-with-select-on-desktop-icon--arrow"
                    path={path}
                    url={faArrowUp}
                  />
                }
                onClick={() => selectNextDiet('up')}
              />
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default BarWithSelectOnDesktop;
